
import React, { useState, useEffect } from "react";

// reactstrap components
import {
  Card,
  CardBody,
  CardHeader,
  Input,
  Button,
} from "reactstrap";
import useGlobal from "store";
import { CSSTransition } from 'react-transition-group';


const OnboardingInputCard = (props) => {

    const [onboardingState, onboardingActions] = useGlobal(
        state => state.onboarding,
        actions => actions.onboardingActions
    );

    

    useEffect(() => {
        let currentStepField = null;
        console.log('onboarding state', onboardingState);
        if(!onboardingState) {
            return;
        }
        currentStepField = onboardingState.formValues.filter(item => onboardingState.current_step === item.name);
        if(currentStepField.length === 0) {
            return;
        }
        setInputValue({
            name: props.step.slug,
            value: currentStepField.value
        });
    }, [onboardingState, props.step.slug]);

    const [inputValue, setInputValue] = useState({
        name: props.step.slug,
        value: ''
    });

    const handleInputChange = (event) => {
        const target = event.target;
        const val = target.type === 'checkbox' ? target.checked : target.value;
        console.log('setting value of ' + props.step.slug + ' to ' + val);
        setInputValue({
            name: props.step.slug,
            value: val
        });
    }

    const nextField = () => {
        console.log('PROPS', props, props.section);
        onboardingActions.nextStep(props.section);
    }

    const testFn = (show) => {
        console.log('TEST FN', show);
    }

  return ( 
        <CSSTransition
            in={onboardingState.current_step === props.step.slug}
            timeout={1000}
            classNames="onboarding-input"
            unmountOnExit
            onEnter={() => testFn(false)}
            onExited={() => testFn(true)}
        >
            <Card className="">
                <CardHeader>
                    <p>{props.step.label}</p>
                    <Input 
                        type={props.step.type || "text"}
                        placeholder={props.step.placeholder || ""}
                        onChange={handleInputChange} 
                        name={props.step.slug}
                        value={inputValue.value || ''}
                        >
                            {props.step.type === "select" ? 
                                props.step.options.map((op,i) => <option key={i}>{op}</option>)
                                : <></>}
                        </Input>
                </CardHeader>
                <CardBody className="text-right">
                    <Button color="primary" onClick={nextField}>Next</Button>
                </CardBody>
            </Card>
        </CSSTransition>
    );
}

export default OnboardingInputCard;
